import React, { useRef } from 'react';
import { FileTemplateExport, ArrowDownDark } from '@icons';
import { Button, ButtonToolbar, Spinner } from 'react-bootstrap';
import { getProjectsTemplate, massImportProjects } from '@lib/api_ts/projectsApi';
import { OETrans } from '@components/translation/OETrans';
import { RejectModal, SuccessModal } from '@components/atomic/organisms';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const ImportExportButtons = () => {
	const fileInputRef = useRef(null);
	const queryClient = useQueryClient();

	const { isFetching: isFetchingTemplate, refetch: refetchTemplate } = useQuery({
		queryKey: ['projects-import'],
		queryFn: async () => {
			const response = await getProjectsTemplate();
			return response;
		},
		enabled: false, // Disabilita il fetch automatico
	});

	const {
		data: massImportApiResponse,
		mutate: massImportMutate,
		isPending: isPendingMassImport,
		isSuccess: isSuccessMassImport,
		reset: resetMassImport,
	} = useMutation({
		mutationFn: massImportProjects,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['projects'] });
		},
	});

	const handleFileChange = (event) => {
		const file = event.target.files?.[0];
		if (!file) return;
		massImportMutate(file);
		event.target.value = '';
	};

	return (
		<>
			<ButtonToolbar className="">
				<Button
					onClick={() => {
						refetchTemplate();
					}}
					className="btn custom-ghost-button"
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '0.5rem',
						fontWeight: '500',
						lineHeight: '28px',
					}}
				>
					<span style={{ display: 'inline-flex', width: '1.25rem', height: '1.25rem', alignItems: 'center', justifyContent: 'center' }}>
						{isFetchingTemplate ? (
							<Spinner animation="border" role="status" size="sm">
								<span style={{ visibility: 'hidden' }}>
									<OETrans code="common.loading" fallback={'Caricamento'} />
									...
								</span>
							</Spinner>
						) : (
							<FileTemplateExport
								// style={{
								// 	// fill: '#1C2743'
								// 	fill: 'var(--np-primary-color)',
								// }}
								width={15}
								height={20}
							/>
						)}
					</span>
					Template
				</Button>
				<Button
					onClick={() => {
						fileInputRef.current?.click();
					}}
					className="btn custom-ghost-button"
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '0.5rem',
						fontWeight: '500',
						lineHeight: '28px',
					}}
				>
					<span style={{ display: 'inline-flex', width: '1.25rem', height: '1.25rem', alignItems: 'center', justifyContent: 'center' }}>
						{isPendingMassImport ? (
							<Spinner animation="border" role="status" size="sm">
								<span style={{ visibility: 'hidden' }}>
									<OETrans code="common.loading" fallback={'Caricamento'} />
									...
								</span>
							</Spinner>
						) : (
							<ArrowDownDark
								style={{
									rotate: '180deg',
									//  fill: '#1C2743'
								}}
							/>
						)}
					</span>
					Importa
				</Button>
				<input
					type="file"
					ref={fileInputRef}
					onChange={handleFileChange}
					style={{ display: 'none' }}
					accept=".csv,.xlsx,.xls" // opzionale: tipi di file supportati
				/>
			</ButtonToolbar>

			<SuccessModal
				show={isSuccessMassImport && massImportApiResponse?.success === true}
				onHide={resetMassImport}
				message="Import massivo completato con successo."
			/>

			<RejectModal
				show={isSuccessMassImport && massImportApiResponse?.success === false}
				onHide={resetMassImport}
				message={massImportApiResponse?.error || 'Non è stato possibile importare massivamente i progetti.'}
				tryAgain={() => massImportMutate(fileInputRef.current?.files?.[0])}
			/>
		</>
	);
};
export default ImportExportButtons;
